import { Link } from "react-router-dom";
import { Lock, ArrowRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { hasFeature, FEATURE_MIN_PLAN, PLAN_LABELS } from "@/lib/plans";

export function PlanGate({ feature, title, children }) {
  const { user } = useAuth();
  const plan = user?.plan || "core";
  if (hasFeature(plan, feature)) return children;
  const need = PLAN_LABELS[FEATURE_MIN_PLAN[feature]] || "a higher";
  return (
    <div className="max-w-2xl mx-auto mt-16 border border-zinc-200 bg-white p-12 text-center" data-testid="plan-gate">
      <div className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-[#0B1F33] text-white mb-6">
        <Lock className="h-6 w-6" strokeWidth={1.8} />
      </div>
      <p className="font-mono-data text-xs uppercase tracking-[0.2em] text-[#B54747]">Locked</p>
      <h1 className="font-display text-4xl font-light mt-2">{title || "This feature is locked"}</h1>
      <p className="text-zinc-500 mt-3">
        Your firm is on the <span className="font-medium capitalize">{plan}</span> plan. Upgrade to{" "}
        <span className="font-medium">{need}</span> or higher to unlock it.
      </p>
      <Button asChild className="mt-8 bg-[#0B1F33] text-white rounded-none h-11 px-6 group hover:bg-zinc-800" data-testid="plan-gate-upgrade">
        <Link to="/app/billing">
          View plans &amp; upgrade
          <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
        </Link>
      </Button>
    </div>
  );
}

export default PlanGate;
